<script lang="ts" setup>
withDefaults(defineProps<{
    disabled?: boolean
    id: string
    modelValue: boolean
    name: string
    label?: string
  }>(),
  {
    disabled: false,
    label: undefined
  }
)

defineEmits(['update:modelValue'])
</script>

<template>
  <label class="form__checkbox">
    <input
      :id="id"
      :checked="modelValue"
      :disabled="disabled"
      :name="name"
      type="checkbox"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    >
    <span :class="{'is--disabled': disabled}" class="form__cm" />
    <template v-if="label">{{ label }}</template>
  </label>
</template>

<style lang="scss" scoped>
.is--disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
